module.exports = __webpack_public_path__ + "img/vendor-icon-makeup.3bb032c0.png";